<template>
  <div
    class="rules"
    :style="{ backgroundColor: activityInfo && activityInfo.new_background }"
  >
    <div v-if="activityInfo">
      <div class="content">
        <div class="title">活动规则</div>
        <div class="list">
          <!-- <div class="item" v-for="(item, index) in memberRules" :key="index">
          <div class="index">{{ (index + 1) | filterIndex }}.</div>
          <div class="item-right" v-html="item.text"></div>
        </div> -->
          <div class="" v-html="rulesData"></div>
        </div>
      </div>
      <img
        class="logo"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
        alt=""
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activityInfo: null,
      type: 0
    }
  },
  filters: {
    filterIndex(index) {
      if (index < 10) {
        index = '0' + index
      }
      return index
    }
  },
  computed: {
    rulesData() {
      if (this.type == 0) {
        return this.activityInfo.invited_activity_rule
      } else {
        return this.activityInfo.invitation_activity_rule
      }
    }
  },
  created() {
    this.init()
    this.getData()
  },
  methods: {
    init() {
      let type = this.$route.query.type
      if (type) {
        this.type = +type
      }
    },
    getData() {
      let params = {
        id: this.$route.query.activityId
      }
      this.$http
        .getBaseApp('member/ActivitySys/getActivityInfo', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.activityInfo = res.data
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.loaded = true
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.rules {
  padding: 0px 25px 89px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  background-repeat: no-repeat;
  background-position: center top;
  background-size: contain;
  background: #e1d8ff;
  .content {
    margin-top: 32px;
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 152px;
    .title {
      text-align: center;
      font-size: 20px;
      font-family: Alibaba-PuHuiTi-B, Alibaba-PuHuiTi;
      font-weight: 600;
      color: #55417a;
      line-height: 27px;
      margin-bottom: 18px;
    }
    .list {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #55417a;
      line-height: 24px;
      .item {
        display: flex;
        align-items: flex-start;
        padding-top: 10px;
        .index {
          margin-right: 7px;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #55417a;
          line-height: 28px;
        }
        .item-right {
          padding-bottom: 10px;
          flex: 1;
          flex-shrink: 0;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #55417a;
          line-height: 24px;
          border-bottom: 1px solid #f1f1f1;
        }
      }
    }
  }
  .logo {
    height: 18px;
    margin: 0 auto;
  }
}
</style>
